/**
 * FCLO — Load More for collection pages.
 * Appends the next page of products via the Section Rendering API.
 * Document-level listener so it survives the theme's AJAX filter rebuilds.
 */
(function () {
  'use strict';

  if (window.__fcloLoadMoreInit) return;
  window.__fcloLoadMoreInit = true;

  var isLoading = false;

  function textEl(btn) {
    return btn.querySelector('[data-fclo-load-more-text]');
  }

  function setBusy(btn, busy) {
    isLoading = busy;
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.classList.toggle('is-loading', busy);
    var t = textEl(btn);
    if (t) t.textContent = busy ? 'Loading…' : 'Load more';
  }

  function calmImages(scope) {
    scope.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('fetchpriority', 'low');
    });
  }

  function updateCount(currentGrid) {
    var el = document.querySelector('[data-fclo-load-more-count]');
    if (!el) return;
    var total = parseInt(el.getAttribute('data-total'), 10);
    var shown = currentGrid.children.length;
    if (!isNaN(total)) {
      el.textContent = 'Showing ' + shown + ' of ' + total + ' products';
    }
  }

  function loadMore(btn) {
    if (isLoading) return;

    var nextUrl = btn.getAttribute('data-next-url');
    var sectionId = btn.getAttribute('data-section-id');
    if (!nextUrl || !sectionId) return;

    var currentGrid = document.querySelector('.collection-page-grid .js-grid');
    if (!currentGrid) return;

    var url;
    try {
      url = new URL(nextUrl, window.location.origin);
    } catch (e) {
      return;
    }
    url.searchParams.set('section_id', sectionId);

    setBusy(btn, true);

    fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.js-grid');
        if (!newGrid) throw new Error('No grid in response');

        var items = Array.prototype.slice.call(newGrid.children);
        if (!items.length) throw new Error('No products in response');

        // Build off-DOM and insert once. Your filter script watches this grid with a
        // MutationObserver — a fragment gives it one mutation instead of dozens,
        // and costs a single reflow instead of one per product.
        var firstNew = items[0];
        var frag = document.createDocumentFragment();
        items.forEach(function (item) {
          calmImages(item);
          frag.appendChild(item);
        });
        currentGrid.appendChild(frag);

        updateCount(currentGrid);

        // The freshly rendered section carries the link to the page after this one.
        var nextBtn = doc.querySelector('[data-fclo-load-more]');
        var followingUrl = nextBtn && nextBtn.getAttribute('data-next-url');

        if (followingUrl) {
          btn.setAttribute('data-next-url', followingUrl);
          setBusy(btn, false);
        } else {
          btn.remove();
          isLoading = false;
        }

        // Send keyboard focus to the first newly loaded product.
        var focusTarget = firstNew && firstNew.querySelector('a[href]');
        if (focusTarget) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
      })
      .catch(function () {
        setBusy(btn, false);
        var t = textEl(btn);
        if (t) t.textContent = 'Try again';
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fclo-load-more]');
    if (!btn) return;
    event.preventDefault();
    loadMore(btn);
  });
})();